import { useMutation, useQuery } from "react-query";
import withdrawal, { WithdrawalResponse } from "../services/getWithdraw";
import {
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_SortingState,
} from "mantine-react-table";

function useWithdrawal(
  token: string,
  pagination: MRT_PaginationState,
  columnFilters: MRT_ColumnFiltersState,
  sorting: MRT_SortingState
) {
  return useQuery<WithdrawalResponse>({
    queryKey: ["withdrawal", pagination, columnFilters, sorting],
    queryFn: () => withdrawal({ token, pagination, columnFilters, sorting }),
    retry: false,
    keepPreviousData: true,
    staleTime: 30_000,
  });
}

export default useWithdrawal;
